var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntro1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 33.75V41.25",
    stroke: "#FCFCFC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 78.75V86.25",
    stroke: "#FCFCFC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 105C85.3528 105 105.5 84.8528 105.5 60C105.5 35.1472 85.3528 15 60.5 15C35.6472 15 15.5 35.1472 15.5 60C15.5 84.8528 35.6472 105 60.5 105Z",
    stroke: "#FCFCFC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.25 78.75H66.125C68.6114 78.75 70.996 77.7623 72.7541 76.0041C74.5123 74.246 75.5 71.8614 75.5 69.375C75.5 66.8886 74.5123 64.504 72.7541 62.7459C70.996 60.9877 68.6114 60 66.125 60H54.875C52.3886 60 50.004 59.0123 48.2459 57.2541C46.4877 55.496 45.5 53.1114 45.5 50.625C45.5 48.1386 46.4877 45.754 48.2459 43.9959C50.004 42.2377 52.3886 41.25 54.875 41.25H71.75",
    stroke: "#FCFCFC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntro1);
export default __webpack_public_path__ + "static/media/intro_1.342af8e45b8347da3980cd97437658df.svg";
export { ForwardRef as ReactComponent };